import { Table, Collapse, Button, Breadcrumb, Space } from "antd";

import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import { SearchColumn } from "../../../../components/SearchColumn/SearchColumn";
import { openNotification } from "../../../../components/Notification";
import { denuncianteService } from "../../../../services";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../contexts/UserContext";
import { urls, USER_ROLES } from "../../../../utils";
import {
  CaretRightOutlined,
  EyeOutlined,
  FileSearchOutlined,
  HomeOutlined,
} from "@ant-design/icons";

const { Panel } = Collapse;
const AtendimentosEncaminhamentos = () => {
  const history = useHistory();

  const { user, cities } = useContext(UserContext);
  const [denunciations, setDenunciations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getForwardins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getForwardins = async () => {
    setLoading(true);
    try {
      const response =
        await denuncianteService.getDenunciationsWithForwardinsByInstitution({
          codigoInstituicaoDestinataria: user.codigo_instituicao,
        });
      setDenunciations(response?.data);
    } catch (error) {
      openNotification(
        "error",
        <strong>Erro!</strong>,
        error?.response?.detail
      );
    }

    setLoading(false);
  };

  const columns = [
    {
      title: <strong>protocolo</strong>,
      dataIndex: ["denunciaIdentificadorExterno"],
      key: "denunciaIdentificadorExterno",
      ...SearchColumn("denunciaIdentificadorExterno", "protocolo"),
    },
    {
      title: <strong>canal</strong>,
      dataIndex: "denunciaCanalDescricao",
      key: "canalDescricao",
      responsive: ["md"],
    },
    {
      title: <strong>municipio</strong>,
      dataIndex: "denunciaMunicipio",
      key: "denunciaMunicipio",
      filters: cities.map(({ nome, codigo }) => ({
        text: nome,
        value: nome,
        key: codigo,
      })),
      onFilter: (value, record) =>
        record.denunciaMunicipio.indexOf(value) === 0,
      filterSearch: true,
      responsive: ["md"],
    },
    {
      title: <strong>início</strong>,
      dataIndex: "dataInicio",
      key: "dataInicio",
      responsive: ["sm"],
      render: (init) => (init ? moment(init).format("DD/MM/yyyy") : ""),
    },
    {
      title: <strong>prazo</strong>,
      dataIndex: "dataPrevistaConclusao",
      key: "dataPrevistaConclusao",
      responsive: ["sm"],
      render: (end) => (end ? moment(end).format("DD/MM/yyyy") : ""),
    },
    {
      title: <strong>ações</strong>,
      key: "action",
      render: ({ denunciaCodigo, denunciaIdentificadorExterno, codigo }) => (
        <Space size="small" style={{ display: "flex", justifyContent: "end" }}>
          {user?.authorities?.includes(
            USER_ROLES.CONSULTAR_ENCAMINHAMENTOS_INSTITUICAO
          ) && (
            <Button
              className="action-button"
              type="primary"
              ghost
              onClick={(event) => {
                event.stopPropagation();
                history.push(
                  urls.ENCAMINHAMENTO_DETAILS.replace(":codigo", codigo)
                );
              }}
              title={`Visualizar encaminhamento da denúncia ${denunciaIdentificadorExterno}`}
            >
              <EyeOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
          )}
          {user?.authorities?.includes(
            USER_ROLES.CONSULTAR_DETALHE_DENUNCIA
          ) && (
            <Button
              className="action-button"
              type="primary"
              onClick={(event) => {
                event.stopPropagation();
                history.push(
                  urls.DENUNCIA_DETAILS.replace(":codigo", denunciaCodigo)
                );
              }}
              title={`Visualizar denúncia ${denunciaIdentificadorExterno}`}
            >
              <FileSearchOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div id="sectionMain">
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item key="home">
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="registros">registros</Breadcrumb.Item>
        <Breadcrumb.Item key="encaminhamentos">
          <strong>encaminhamentos</strong>
        </Breadcrumb.Item>
      </Breadcrumb>

      <div>
        <div className="container-section">
          <div id="header-container">
            <div>
              <h2>LISTA DE ENCAMINHAMENTOS</h2>
              <span>
                atualizado ás {moment().format("HH:mm")} do dia{" "}
                {moment().format("DD/MM/YYYY")}
              </span>
            </div>

            <div id="header-actions">
              {user?.authorities?.includes(USER_ROLES.INCLUIR_DENUNCIA) && (
                <Link to={urls.DENUNCIA_CRIAR} className="button-link">
                  <Button type="primary" style={{ width: "160px" }}>
                    nova denúncia
                  </Button>
                </Link>
              )}
            </div>
          </div>
          <Collapse
            className="collapse-personal"
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            expandIconPosition="right"
            ghost
          >
            <Panel
              header={<strong>encaminhamentos em aberto</strong>}
              key="1"
              className="linear-red"
            >
              <Table
                dataSource={denunciations.filter(
                  ({ statusDescricao }) => statusDescricao === "EM ABERTO"
                )}
                columns={columns}
                size="small"
                rowKey={({ codigo }) => codigo}
                onRow={(record) => {
                  return {
                    onClick: () =>
                      history.push(
                        urls.ENCAMINHAMENTO_DETAILS.replace(
                          ":codigo",
                          record.codigo
                        )
                      ), // click row
                  };
                }}
                pagination={{
                  size: "small",
                  showSizeChanger: true,
                  total: denunciations.length,
                  showTotal: (total) => (
                    <strong>
                      {total === 1
                        ? `${total} encaminhamento no total`
                        : `${total} encaminhamentos no total`}
                    </strong>
                  ),
                }}
              />
            </Panel>

            <Panel
              header={<strong>encaminhamentos em andamento</strong>}
              key="2"
              className="linear-yellow"
            >
              <Table
                dataSource={denunciations.filter(
                  ({ statusDescricao }) =>
                    statusDescricao === "A VALIDAR" ||
                    statusDescricao === "EM ANDAMENTO"
                )}
                loading={loading}
                columns={columns}
                size="small"
                rowKey={({ codigo }) => codigo}
                onRow={(record) => {
                  return {
                    onClick: () =>
                      history.push(
                        urls.ENCAMINHAMENTO_DETAILS.replace(
                          ":codigo",
                          record.codigo
                        )
                      ), // click row
                  };
                }}
                pagination={{
                  size: "small",
                  showSizeChanger: true,
                }}
              />
            </Panel>

            <Panel
              header={<strong>encaminhamentos finalizados</strong>}
              key="3"
              className="linear-green"
            >
              <Table
                dataSource={denunciations.filter(
                  ({ statusDescricao }) => statusDescricao === "FINALIZADA"
                )}
                columns={columns}
                loading={loading}
                size="small"
                rowKey={({ codigo }) => codigo}
                onRow={(record) => {
                  return {
                    onClick: () =>
                      history.push(
                        urls.ENCAMINHAMENTO_DETAILS.replace(
                          ":codigo",
                          record.codigo
                        )
                      ),
                  };
                }}
                pagination={{
                  size: "small",
                  showSizeChanger: true,
                }}
              />
            </Panel>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default AtendimentosEncaminhamentos;
